import { getFromServerTopic } from "@utility/slice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDLE, LOADING } from "@constants";

const SLICE = "contacts";

const getFromServer = (action, contextOptionsFn, payloadFn) =>
  getFromServerTopic({ topic: SLICE, action, contextOptionsFn, payloadFn });

const action = (name) => `${SLICE}/${name}`;

const performRemoveMFA = getFromServer("removeMFA");
const performRegenerateRecoveryCodes = getFromServer("regenerateRecoveryCodes");

export const getMFADetails = getFromServer("getMFADetails");

export const verifyMFAToken = getFromServer("verifyMFAToken", ({ arg }) => ({
  token: arg.token,
  isTrustDevice: arg.isTrustDevice,
}));

export const verifyRecoveryCode = getFromServer(
  "verifyRecoveryCode",
  ({ arg }) => ({
    recoveryCode: arg.token,
    isTrustDevice: arg.isTrustDevice,
  }),
);

export const verifyTrustedDevice = getFromServer(
  "verifyTrustedDevice",
  ({ arg }) => ({
    trustedDevice: arg.trustedDevice,
  }),
);

export const regenerateRecoveryCodes = createAsyncThunk(
  action("regenerateRecoveryCodes"),
  async (arg, { dispatch }) => {
    await dispatch(performRegenerateRecoveryCodes(arg));
    return dispatch(getMFADetails());
  },
);

export const removeMFA = createAsyncThunk(
  action("removeMFA"),
  async (arg, { dispatch }) => {
    await dispatch(performRemoveMFA(arg));
    return dispatch(getMFADetails());
  },
);

export const slice = createSlice({
  name: SLICE,
  initialState: {
    status: IDLE,
  },
  reducers: {
    tokenUpdated: (state) => {
      state.isValidToken = undefined;
    },
    userLoggedIn: (state) => {
      state.isValidToken = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMFADetails.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(getMFADetails.fulfilled, (state, action) => {
        const { payload } = action;
        const { isMFAEnabled, mfaSecret, qrCode, recoveryCodes } =
          payload.response;

        state.status = IDLE;
        state.isMFAEnabled = isMFAEnabled;
        state.mfaSecret = mfaSecret;
        state.qrCode = qrCode;
        state.recoveryCodes = recoveryCodes;
      })
      .addCase(verifyMFAToken.fulfilled, (state, action) => {
        const { payload } = action;
        const { isValid, trustedDevice } = payload.response;

        state.isValidToken = isValid;
        state.trustedDevice = trustedDevice;
        if (isValid) state.isMFAEnabled = true;
      })
      .addCase(verifyRecoveryCode.fulfilled, (state, action) => {
        const { payload } = action;
        const { isValid, trustedDevice } = payload.response;
        state.isValidToken = isValid;
        state.trustedDevice = trustedDevice;
      })
      .addCase(verifyTrustedDevice.fulfilled, (state, action) => {
        const { payload } = action;
        const { isValid } = payload.response;

        state.isValidToken = isValid;
      });
  },
});

export const { tokenUpdated, userLoggedIn } = slice.actions;

export default slice.reducer;
